const lazySizes = require('lazysizes/lazysizes');
lazySizes.cfg.loadMode = 1; // only load visible elements
module.exports = lazySizes;



// WEBPACK FOOTER //
// /node_modules/@mands/mns-fe-pattern-library/lib/mns-fe-utilities/lazy-load/index.js